import { useSetAtom } from 'jotai';
import React, { useCallback } from 'react';

import { Button, Grid, Header, Icon } from '~/components/blocks';
import { SETTING_TITLES } from '~/components/layouts/Settings/RootMenu';
import { usePractitionerRole } from '~/hooks/use-practitioner-role';
import { editDrawerState, newDrawerState } from '~/state/settings_practitioners/atoms';

import { CompleteRegistrationModal } from './CompleteRegistrationModal';
import { DeletePractitionerModal } from './DeletePractitionerModal';
import { EditPractitionerDrawer } from './EditPractitionerDrawer';
import { NewPractitionerDrawer } from './NewPractitionerDrawer';
import { PractitionerList } from './PractitionerList';
import { ResetPasswordModal } from './ResetPasswordModal';

export const Practitioners = () => {
  const setEditDrawer = useSetAtom(editDrawerState);
  const setNewDrawer = useSetAtom(newDrawerState);

  const handleOpenNewDrawer = useCallback(() => {
    setEditDrawer((_state) => ({ ..._state, isOpen: false }));
    setNewDrawer((_state) => ({ ..._state, isOpen: true }));
  }, [setEditDrawer, setNewDrawer]);
  const { verifyRole } = usePractitionerRole();

  return (
    <>
      <Grid height="100%" gridTemplateRows="min-content 1fr" gridTemplateColumns="1fr">
        <Header
          action={
            <Button onClick={handleOpenNewDrawer} disabled={!verifyRole('admin')}>
              <Icon size="m" icon="plus" />
              スタッフ追加
            </Button>
          }
        >
          {SETTING_TITLES.practitioners}
        </Header>
        <PractitionerList />
      </Grid>

      <EditPractitionerDrawer />
      <NewPractitionerDrawer />
      <CompleteRegistrationModal />
      <DeletePractitionerModal />
      <ResetPasswordModal />
    </>
  );
};
